import React from 'react';
import * as Logger from 'loglevel';
import { DataTableConstant } from 'hub-dashboard-framework';
import {
    isWorkingFolder,
    isElasticSearchActive,
    isCurrentUser,
    getFolderById,
    createNotification
} from './ScnHelpers';

export class ScnReducer {

    onScnNotification = (state, message, folder) => {
        Logger.debug("Creating notification", { message, folder });

        const notificationObj = createNotification(message, folder);

        return {
            ...state,
            notificationObj: notificationObj
        };
    };

    onScnAddObject = (state, scnContent) => {
        Logger.debug("Processing add object notification", scnContent);


        if (isWorkingFolder(state, scnContent.folderId) &&
            !isElasticSearchActive(state)) {

            Logger.debug(`Adding object = ${scnContent.hubObject.id} in Folder with Id: ${scnContent.folderId}`);

            let newState = {
                ...state,
                objectList: [
                    scnContent.hubObject
                ].concat(state.objectList),
                bTriggerUpdate: true
            };

            newState.action = DataTableConstant.HUB_ACTION_STATE.ADD_ROW;
            return newState;
        }


        if (!isWorkingFolder(state, scnContent.folderId) &&
            scnContent.hubUser &&
            !isCurrentUser(scnContent.hubUser.userId)) {

            const user = scnContent.hubUser;
            const folder = getFolderById(state, scnContent.folderId);

            if (!folder) {
                Logger.debug("Folder not found", scnContent.folderId);
                return state;
            }

            const message = (
                <span>
                    '<strong>{scnContent.hubObject.name}</strong>' has been added to <strong>{folder.name}</strong> by <strong>{user.userName}</strong>
                </span>
            );


            return this.onScnNotification(state, message, folder);
        }

        Logger.debug("Add operation didn't match any conditions");
        return state;
    }

    onScnDeleteObject = (state, scnContent) => {
        Logger.debug("Processing delete object notification", scnContent);


        if (isWorkingFolder(state, scnContent.folderId)) {
            Logger.debug(`Deleting object = ${scnContent.objectId} from Folder with Id: ${scnContent.folderId}`);

            let newObjectList = state.objectList.filter(o => (o.id !== scnContent.objectId));
            Logger.debug('objectList after deletion', newObjectList);

            let next_state = {
                ...state,
                objectList: newObjectList,
                bTriggerUpdate: true
            };

            next_state.action = DataTableConstant.HUB_ACTION_STATE.DELETE_ROW;
            Logger.debug('next_state after deletion', next_state);

            return next_state;
        }

        // NOTIFICATIONS TEMPORARILY REMOVED FOR DELETES
        // You can uncomment this when you want to re-enable delete notifications
        /*
        if (!isWorkingFolder(state, scnContent.folderId) && 
            scnContent.userId && 
            !isCurrentUser(scnContent.userId)) {
            
            const folder = getFolderById(state, scnContent.folderId);
            
            if (!folder) {
                Logger.debug("Folder not found", scnContent.folderId);
                return state;
            }
            
            const message = `A story has been deleted from ${folder.name}`;
            
            // Use the notification method
            return this.onScnNotification(state, message, folder);
        }
        */

        Logger.debug("Delete operation didn't match any conditions");
        return state;
    }

    onScnMoveObject = (state, scnContent) => {
        Logger.debug("Processing move object notification", scnContent);


        if (isWorkingFolder(state, scnContent.hubObject.folderId) &&
            !isElasticSearchActive(state)) {

            Logger.debug(`Adding moved object = ${scnContent.hubObject.id} in folder with Id: ${scnContent.hubObject.folderId}`);

            let newState = {
                ...state,
                objectList: [
                    scnContent.hubObject
                ].concat(state.objectList),
                bTriggerUpdate: true
            };

            newState.action = DataTableConstant.HUB_ACTION_STATE.ADD_ROW;
            return newState;
        }

        else if (isWorkingFolder(state, scnContent.folderId)) {
            Logger.debug(`Removing moved object = ${scnContent.hubObject.id} from Folder with Id: ${scnContent.folderId}`);

            let newObjectList = state.objectList.filter(o => (o.id !== scnContent.hubObject.id));
            Logger.debug('objectList after removing moved object', newObjectList);

            let next_state = {
                ...state,
                objectList: newObjectList,
                bTriggerUpdate: true
            };

            next_state.action = DataTableConstant.HUB_ACTION_STATE.DELETE_ROW;
            Logger.debug('next_state after removing moved object', next_state);

            return next_state;
        }


        if (!isWorkingFolder(state, scnContent.hubObject.folderId) &&
            !isWorkingFolder(state, scnContent.folderId) &&
            scnContent.hubUser &&
            !isCurrentUser(scnContent.hubUser.id)) {

            const destinationFolder = getFolderById(state, scnContent.hubObject.folderId);
            const sourceFolder = getFolderById(state, scnContent.folderId);

            if (!destinationFolder || !sourceFolder) {
                Logger.debug("Source or destination folder not found", {
                    sourceFolderId: scnContent.folderId,
                    destFolderId: scnContent.hubObject.folderId
                });
                return state;
            }

            const user = scnContent.hubUser;
            const message = (
                <span>
                    '<strong>{scnContent.hubObject.name}</strong>' has been moved from <strong>{sourceFolder.name}</strong> to <strong>{destinationFolder.name}</strong> by <strong>{user.userName}</strong>
                </span>
            );

            return this.onScnNotification(state, message, destinationFolder);
        }

        Logger.debug("Move operation didn't match any conditions");
        return state;
    }

    onScnUpdateObject = (state, scnContent) => {
        Logger.debug("Processing update object notification", scnContent);

        if (isWorkingFolder(state, scnContent.folderId) &&
            !isElasticSearchActive(state)) {
            Logger.debug(`Updating object = ${scnContent.hubObject.id} in Folder with Id: ${scnContent.folderId}`);

            // Create a new object list with the updated object
            let updatedObjectList = state.objectList.map(obj =>
                obj.id === scnContent.hubObject.id ? scnContent.hubObject : obj
            );

            let newState = {
                ...state,
                objectList: updatedObjectList,
                bTriggerUpdate: true
            };

            newState.action = DataTableConstant.HUB_ACTION_STATE.REFRESH;
            return newState;
        }

        if (!isWorkingFolder(state, scnContent.folderId) &&
            scnContent.hubUser &&
            !isCurrentUser(scnContent.hubUser.userId)) {
            const folder = getFolderById(state, scnContent.folderId);

            if (!folder) {
                Logger.debug("Folder not found", scnContent.folderId);
                return state;
            }
            const user = scnContent.hubUser;
            const message = (
                <span>
                    '<strong>{scnContent.hubObject.name}</strong>' has been updated in <strong>{folder.name}</strong> by <strong>{user.userName}</strong>
                </span>
            );
            return this.onScnNotification(state, message, folder);
        }

        Logger.debug("Update operation didn't match any conditions");
        return state;
    }

    onScnDeleteObjects = (state, scnContent) => {
        Logger.debug("Processing delete objects notification", scnContent);


        if (state.objectList &&
            scnContent.objectIdList &&
            scnContent.objectIdList.length > 0) {

            Logger.debug('Deleting objects with nodeId=', scnContent.nodeId);
            Logger.debug('Delete objects content', scnContent);

            let newObjectList = state.objectList.filter(o => !scnContent.objectIdList.includes(o.objectId));

            return {
                ...state,
                objectList: newObjectList,
                bTriggerUpdate: true
            };
        }

        // NOTIFICATIONS TEMPORARILY REMOVED FOR DELETES
        // You can uncomment this when you want to re-enable delete notifications
        /*
        if (!isWorkingFolder(state, scnContent.folderId) && 
            scnContent.userId && 
            !isCurrentUser(scnContent.userId)) {
            
            const folder = getFolderById(state, scnContent.folderId);
            
            if (!folder) {
                Logger.debug("Folder not found", scnContent.folderId);
                return state;
            }
            
            let newObjectList = state.objectList.filter(o => !scnContent.objectIdList.includes(o.objectId));
            const deletedStoriesCount = state.objectList.filter(o => !newObjectList.includes(o)).length;
            
            const message = `${deletedStoriesCount} stories have been deleted from ${folder.name}`;
            
            // Use the notification method
            return this.onScnNotification(state, message, folder);
        }
        */

        Logger.debug("Delete objects operation didn't match any conditions");
        return state;
    }

    onScnUpdateUser = (state, scnContent) => {

        if (!state.users) {
            return state;
        }

        Logger.debug(`Adding or updating user, payload:`, scnContent);

        const user = scnContent.user;
        let index = state.users.findIndex(u => u.id === user.id);


        if (index === -1) {
            let newState = {
                ...state,
                users: state.users.concat([user])
            };

            Logger.debug(`Added new user, newstate:`, newState);

            newState.action = DataTableConstant.HUB_ACTION_STATE.ADD_ROW;
            newState.bTriggerUpdate = true;

            return newState;
        }

        else {
            let newState = {
                ...state,
                users: [
                    ...state.users.slice(0, index),
                    user,
                    ...state.users.slice(index + 1, state.users.length)
                ]
            };

            Logger.debug(`Updated user, newstate:`, newState);

            newState.action = DataTableConstant.HUB_ACTION_STATE.MODIFY_ROW;
            newState.bTriggerUpdate = true;

            return newState;
        }
    }

    onScnStoryLockAcquired = (state, scnContent) => {

        // Get lock details
        const objectId = scnContent.objectId;
        const userId = scnContent.userId;
        const connectionId = scnContent.connectionId;

        // Update the story locks in Redux state
        const updatedStoryLocks = {
            ...state.storyLocks,
            [objectId]: {
                userId: userId,
                connectionId: connectionId,
                lockTime: new Date().toISOString()
            }
        };

        let updatedObjectList = state.objectList;
        if (state.objectList) {
            updatedObjectList = state.objectList.map(obj => {
                if (obj.id === objectId) {
                    return {
                        ...obj,
                        lockedBy: userId,
                        lockConnectionId: connectionId,
                        isLocked: true
                    };
                }
                return obj;
            });
        }

        return {
            ...state,
            objectList: updatedObjectList,
            storyLocks: updatedStoryLocks,
            bTriggerUpdate: true
        };
    };

    onScnStoryLockReleased = (state, scnContent) => {
        const objectId = scnContent.objectId;

        const updatedStoryLocks = { ...state.storyLocks };
        delete updatedStoryLocks[objectId];

        let updatedObjectList = state.objectList;
        if (state.objectList) {
            updatedObjectList = state.objectList.map(obj => {
                if (obj.id === objectId) {
                    const updatedObj = { ...obj };
                    delete updatedObj.lockedBy;
                    delete updatedObj.lockConnectionId;
                    updatedObj.isLocked = false;
                    return updatedObj;
                }
                return obj;
            });
        }

        return {
            ...state,
            objectList: updatedObjectList,
            storyLocks: updatedStoryLocks,
            bTriggerUpdate: true
        };
    };
}

const scnReducer = new ScnReducer();
export default scnReducer;